"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductItemSummaryValue = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productItemValueRadios = require("./productItemValues/productItemValueRadios");
var _productItemValueLimit = require("./productItemValues/productItemValueLimit");
var _productItemValueWaitingPeriod = require("./productItemValues/productItemValueWaitingPeriod");
var _labelPropTypes = require("../productTableLabels/defaults/labelPropTypes");
var _dynamicVariantValues = require("./productItemValues/dynamicVariantValues");
var _tickCrossIcons = require("./productItemValues/tickCrossIcons");
var _productItemValueExcess = require("./productItemValues/productItemValueExcess");
var _productItemValueLevelOfCover = require("./productItemValues/productItemValueLevelOfCover");
var _tableContext = require("../productsTable/stateHelpers/tableContext");
var _excessHelper = require("../../helpers/excessHelper");
var _productHelpers = require("../../helpers/productHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */

var ProductItemSummaryValue = exports.ProductItemSummaryValue = function ProductItemSummaryValue(_ref) {
  var labelKey = _ref.labelKey,
    labelDefinition = _ref.labelDefinition,
    coverDetails = _ref.coverDetails,
    productDefinition = _ref.productDefinition;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    AddOnsMap = _useContext$tableCont.AddOnsMap,
    staffMode = _useContext$tableCont.staffMode,
    petSureStaffMode = _useContext$tableCont.petSureStaffMode,
    AllPlans = _useContext$tableCont.AllPlans,
    productsAreMerged = _useContext.tableState.productsAreMerged;
  var customValue = labelDefinition.customValue,
    valueType = labelDefinition.valueType,
    valueMap = labelDefinition.valueMap,
    formatters = labelDefinition.formatters,
    dynamicVariant = labelDefinition.dynamicVariant,
    dynamicVariantValue = labelDefinition.dynamicVariantValue;
  var planNumber = productDefinition.planNumber;
  var value = coverDetails[labelKey];
  var label = labelDefinition.label;
  var _GetAllLevelsOfCover = (0, _productHelpers.GetAllLevelsOfCover)({
      planNumber: planNumber,
      productDefinition: productDefinition,
      AddOnsMap: AddOnsMap,
      AllPlans: AllPlans
    }),
    allLevelsOfCover = _GetAllLevelsOfCover.levelsOfCover,
    stepDownLevelsOfCover = _GetAllLevelsOfCover.stepDownLevelsOfCover;
  var levelsOfCover = productsAreMerged ? allLevelsOfCover : productDefinition.levelsOfCover;
  if (labelKey === 'levelOfCover') {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "labelText"
    }, levelsOfCover.length > 1 ? 'Choose from the following annual benefit limits: ' : 'Annual benefit limit: ', productDefinition.levelsOfCover.map(function (level, index) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: "".concat(planNumber, "_level_").concat(level)
      }, level, "%", index < productDefinition.levelsOfCover.length - 1 && ', ');
    }));
  }
  if (labelKey === 'excess') {
    var excessValues = (0, _excessHelper.FindAllExcessOptionsBasedOnAmount)({
      planNumber: planNumber,
      AddOnsMap: AddOnsMap,
      staffMode: staffMode,
      petSureStaffMode: petSureStaffMode,
      AllPlans: AllPlans
    }).sort(function (a, b) {
      if (a.value < b.value) {
        return -1;
      }
      return 1;
    });
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "labelText"
    }, "Choose from the following excesses:\xA0", excessValues.map(function (excessValue, index) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: "".concat(planNumber, "_excess_").concat(excessValue.value)
      }, "$", excessValue.value, index < excessValues.length - 1 && ', ');
    }));
  }
  if (valueType === 'limit') {
    return /*#__PURE__*/_react["default"].createElement(_productItemValueLimit.ProductItemValueLimit, {
      labelKey: labelKey,
      value: value,
      valueMap: valueMap,
      formatters: formatters,
      productDefinition: productDefinition
    });
  }
  if (valueType === 'custom_waitingPeriods') {
    var waitingPeriodMessages = productDefinition.waitingPeriods.detailed.waitingPeriodMessages;
    if (customValue) {
      return /*#__PURE__*/_react["default"].createElement(_productItemValueWaitingPeriod.ProductItemValueWaitingPeriod, {
        waitingPeriodMessages: customValue,
        planNumber: planNumber
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_productItemValueWaitingPeriod.ProductItemValueWaitingPeriod, {
      waitingPeriodMessages: waitingPeriodMessages
    });
  }
  if (dynamicVariant && dynamicVariantValue) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "labelText"
    }, label);
  }
  if (typeof productDefinition[labelKey] === 'boolean') {
    value = productDefinition[labelKey];
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tickCrossIcons.TickCrossIcons, {
    value: value
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, label));
};
ProductItemSummaryValue.propTypes = {
  labelKey: _propTypes["default"].string,
  labelDefinition: _propTypes["default"].shape(_labelPropTypes.LabelPropTypes),
  coverDetails: _propTypes["default"].any,
  productDefinition: _propTypes["default"].any
};
var _default = exports["default"] = {
  ProductItemSummaryValue: ProductItemSummaryValue
};